import API from "../../../app/api";
export const persistCartContext = ({ cartType, userId, customerId }) => {
  if (cartType) {
    localStorage.setItem("cartType", cartType);
  }
  if (userId != null) {
    localStorage.setItem("userId", String(userId));
  }
  if (customerId != null) {
    localStorage.setItem("customerId", String(customerId));
  }
};
export const getcart = async (cartType, userId, customerId) => {
  const type =
    cartType ||
    localStorage.getItem("cartType") ||
    "customer";

  const uid =
    userId ??
    localStorage.getItem("userId");
  const cid =
    customerId ??
    localStorage.getItem("customerId");

  if (!uid || !cid) {
    return {
      cartTempToken: "",
      cartItems: [],
      cartSummary: {},
      cartCustomer: {},
    };
  }

  try {
    const response = await API.get(
      `/cart/${type}/summary`,
      {
        params: {
          userId: uid,
          customerId: cid,
          _t: Date.now(), // cache bust
        },
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
        },
      }
    );
    const data = response?.data?.data || {};
    return {
      cartTempToken: data.cart_temp_token || "",
      cartItems: Array.isArray(data.cart_items)
        ? data.cart_items
        : [],
      cartSummary: data.cart_summary || {},
      cartCustomer: data.cart_customers || {},
    };
  } catch (error) {
    console.error("Cart Error:", error);

    return {
      cartTempToken: "",
      cartItems: [],
      cartSummary: {},
      cartCustomer: {},
    };
  }
};